import { takeLatest, takeLeading, select, put } from "redux-saga/effects";
import { setPreferredShippingMethod } from "@grandvisionhq/shipping";
import { SAVE_ADDRESS_LOOKUP, PREFILL_SHIPPING_FORMS, SELECT_SHIPPING_METHOD, updateShippingDetails, updateShippingForms } from "./actions.js";
import { mapShippingFormsUpdate } from "../mappers/StepShipping/mappers/map-shipping-forms-update.js";
import { getShippingDetails } from "./selectors.js";
function* onPrefillShippingForms(action) {
  const shippingDetails = yield select(getShippingDetails);
  const cartUpdate = mapShippingFormsUpdate(
    action.payload,
    shippingDetails
  );
  try {
    yield put(updateShippingForms(cartUpdate));
  } catch (e) {
    console.error(e);
  }
}
function* onSelectShippingMethod(action) {
  const shippingMethod = action.payload.shippingMethod;
  if (shippingMethod.method) {
    yield put(
      setPreferredShippingMethod({
        shippingMethodKey: shippingMethod.method
      })
    );
  }
}
function* onAddressLookupSave(action) {
  const checkoutForm = action.payload.formName;
  const shippingDetails = yield select(getShippingDetails);
  const currentForm = shippingDetails[checkoutForm];
  if (!currentForm) {
    console.error(`Saving address lookup failed, could not find form: ${checkoutForm}`);
    return;
  }
  const shippingDetailsUpdate = {
    formName: checkoutForm,
    formValid: currentForm.isValid,
    formState: Object.keys(currentForm.formData).reduce((formData, fieldName) => {
      return {
        ...formData,
        ...fieldName in action.payload.formData ? {
          [fieldName]: {
            name: fieldName,
            isValid: true,
            value: action.payload.formData[fieldName],
            isTouched: true
          }
        } : {}
      };
    }, currentForm.formData)
  };
  try {
    yield put(
      updateShippingDetails({
        form: shippingDetailsUpdate
      })
    );
  } catch (e) {
    console.error(e);
  }
}
const stepShippingSagas = [
  takeLatest(SAVE_ADDRESS_LOOKUP, onAddressLookupSave),
  takeLatest(PREFILL_SHIPPING_FORMS, onPrefillShippingForms),
  takeLeading(SELECT_SHIPPING_METHOD, onSelectShippingMethod)
];
export {
  stepShippingSagas as default,
  onAddressLookupSave,
  onPrefillShippingForms,
  onSelectShippingMethod
};
//# sourceMappingURL=sagas.js.map
